"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgDocumentation(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm13.701 15.277h-.088a1.57558 1.57558 0 0 1 .0163-1.87091l-.006-.004a.451.451 0 0 0 .37579-.445v-12.505a.45026.45026 0 0 0 -.44813-.4519h-9.908a1.65208 1.65208 0 0 0 -1.64331 1.65717v12.686a1.65181 1.65181 0 0 0 1.64331 1.65723h10.06a.30057.30057 0 0 0 .29869-.30139v-.121a.30047.30047 0 0 0 -.29871-.30127m-7.02307-11.89874a1.75775 1.75775 0 0 1 1.16986-.379 2.035 2.035 0 0 1 1.51685.53851 2.09059 2.09059 0 0 1 .63458 1.60547 2.13526 2.13526 0 0 1 -.29751 1.09696 3.90333 3.90333 0 0 1 -.62452.688l-.317.279a1.09972 1.09972 0 0 0 -.30737.52863 4.01778 4.01778 0 0 0 -.0495.56829v.011a.10923.10923 0 0 1 -.10938.10919h-.992a.09113.09113 0 0 1 -.02088 0 .09949.09949 0 0 1 -.08813-.10968 3.00857 3.00857 0 0 1 .23791-1.24655 3.48148 3.48148 0 0 1 .8725-.9273 1.20109 1.20109 0 0 0 .23791-.2992 1.21273 1.21273 0 0 0 .19831-.60828 1.25209 1.25209 0 0 0 -.17853-.698.66293.66293 0 0 0 -.63446-.349.68432.68432 0 0 0 -.62463.44867 1.805 1.805 0 0 0 -.109.8277h-1.19a2.57233 2.57233 0 0 1 .67413-2.0841m1.80811 6.81152a.7776.7776 0 0 1 -.75714.797l-.043-.006a.797.797 0 0 1 -.66058-.91174l-.003-.038a.795.795 0 0 1 .74658-.84c.018.002.036.004.054.007a.80731.80731 0 0 1 .6593.93011c.002.02.003.04.004.061m4.02 4.813-9-.002a.5.5 0 0 1 0-1l9.01.001a.70144.70144 0 0 0 -.00964 1.00049' })));
}
exports.default = SvgDocumentation;
